import { print } from "graphql";
import { Client } from "graphql-ws";
import { getActiveMenuQueryKey } from "./use-get-active-menu";
import { getActiveMenuCategoriesQueryKey } from "./use-get-active-menu-categories";
import { getActiveMenuItemQueryKey } from "./use-get-active-menu-item";
import { reconcileCartForMenuEvent } from "~/libs/realtime";
import {
	SubscribeToMenuDocument,
	SubscribeToMenuSubscription,
} from "~/types/__generated/gql/graphql";
import { queryClient } from "~/providers/query-provider";

void (
	/* GraphQL */ `
		subscription SubscribeToMenu($id: ObjectID!) {
			subscribeToMenu(id: $id) {
				type
				id
				payload {
					menu {
						_id
					}
					category {
						_id
					}
					item {
						_id
					}
				}
			}
		}
	`
);

export const subscribeToMenu = (client: Client, menuId: string) =>
	client.subscribe<SubscribeToMenuSubscription>(
		{
			query: print(SubscribeToMenuDocument),
			variables: { id: menuId },
		},
		{
			next: async (result) => {
				const payload = result.data?.subscribeToMenu?.payload;
				if (!payload) return;

				const menuQueryKey = getActiveMenuQueryKey();
				const categoriesQueryKey = getActiveMenuCategoriesQueryKey();
				const itemId = payload.item?._id;
				const entityType = payload.item
					? "item"
					: payload.category
						? "category"
						: "menu";
				const entityId =
					payload.item?._id ?? payload.category?._id ?? payload.menu?._id;

				await Promise.all([
					queryClient.invalidateQueries({
						queryKey: menuQueryKey,
						exact: true,
					}),
					queryClient.invalidateQueries({
						queryKey: categoriesQueryKey,
						exact: true,
					}),
					queryClient.invalidateQueries({
						queryKey: ["getActiveMenuItemsQr"],
					}),
					itemId
						? queryClient.invalidateQueries({
								queryKey: getActiveMenuItemQueryKey({ id: itemId }),
								exact: true,
							})
						: Promise.resolve(),
				]);

				reconcileCartForMenuEvent({
					entityType,
					entityId,
				});
			},
			error: (error) => console.error(error),
			complete: () => undefined,
		},
	);
